import React, { useEffect, useState, useRef } from "react";
import { FaStar } from "react-icons/fa";
import ScrollToTopButton from "../../commonComponents/go-up-button/scrollToTopButton";
import { useForm } from "react-hook-form";
import "./viewRestaurant.scss";
import { useDispatch, useSelector } from "react-redux";
import addLogo from "../../../assets/addLogo.png";
import { useNavigate } from "react-router-dom";
import ItemCounter from "../../commonComponents/item-counter/itemCounter";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import Celebration from "../../../assets/celebration.png";
import AddToFavorite from "../../commonComponents/add-to-favorite/addToFavorite";
import RateRestaurant from "../../commonComponents/rate-one-to-five/rateRestaurant";
import LogIn from "../../user/userLogin/userLogIn";
import { FaAngleDoubleRight } from "react-icons/fa";
import { FaAngleDoubleLeft } from "react-icons/fa";

function RestaurantView() {
  const restaurantString = sessionStorage.getItem("restaurantClicked");
  const restaurant = JSON.parse(restaurantString);
  const [orderedDishes, setOrderedDishes] = useState([]);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [showConfirmationPayment, setShowConfirmationPayment] = useState(false);
  const [showTimeEstimation, setShowTimeEstimation] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [errorSelectedMethod, setErrorSelectedMethod] = useState(false);
  const [errorOrder, setErrorOrder] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showLogIn, setShowLogIn] = useState(false);
  const navigate = useNavigate();
  const [estimatedTime, setEstimatedTime] = useState(
    Math.floor(restaurant.distance * 10)
      ? Math.floor(restaurant.distance * 10)
      : 0
  );
  const notificationsArray =
    JSON.parse(localStorage.getItem("notifications")) || [];
  const sectionRefs = useRef([]);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSection = (index) => {
    const targetSection = sectionRefs.current[index];
    const offset = 20; // Offset in pixels

    // Calculate the target scroll position including the offset
    const targetScrollPosition = targetSection.offsetTop - offset;

    // Scroll to the target position with smooth behavior
    window.scrollTo({
      top: targetScrollPosition,
      behavior: "smooth",
    });
  };

  const handleConfirmOrder = () => {
    console.log("Confirming order...");
    if (selectedMethod) {
      console.log("Order confirmed!");
      setShowConfirmationPayment(false);
      setErrorSelectedMethod(false);
      setShowTimeEstimation(true);
      const orderTime = new Date();
      const currentTime = new Date().getTime();
      const formattedDate = new Date().toLocaleDateString("en-US");
      notificationsArray.push([
        restaurant.restaurant_name,
        orderedDishes,
        currentTime,
        estimatedTime,
        0,
        total,
        formattedDate,
      ]);
      localStorage.setItem("notifications", JSON.stringify(notificationsArray));
      fetch("https://femez.onrender.com/API/user/addOrdersHistory", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          restaurantName: restaurant.restaurant_name,
          orderedDishes: orderedDishes,
          total: total,
          currentTime: orderTime,
          restaurantId: restaurant._id,
        }),
      });
    } else {
      // Show error if no payment method is selected
      setErrorSelectedMethod(true);
    }
  };

  const handlePaymentMethodSelect = (method) => {
    setSelectedMethod(method);
    // onPaymentMethodSelect(method);
  };
  useEffect(() => {
    const handleResize = () => {
      const sections = document.querySelector(".menu-sections");
      // Check if there's overflow
      if (sections.scrollWidth > sections.clientWidth) {
        // Show the scroll button
        setShowScrollButton(true);
      } else {
        // Hide the scroll button if no overflow
        setShowScrollButton(false);
      }
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleScrollButtonClickRight = () => {
    const container = document.querySelector(".menu-sections-list");
    container.style.overflowX = "auto";
    container.scrollLeft += 250;
  };
  const handleScrollButtonClickLeft = () => {
    const container = document.querySelector(".menu-sections-list");
    container.style.overflowX = "auto";
    container.scrollLeft -= 250;
  };
  useEffect(() => {
    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {}, [isClicked]);
  const handleAddToOrder = (dish, count) => {
    if (count === 0) {
      // If count is 0, remove the dish from orderedDishes
      const updatedDishes = orderedDishes.filter(
        (item) => item.dish.dish_name !== dish.dish_name
      );
      setOrderedDishes(updatedDishes);
      return;
    }

    const existingDish = orderedDishes.find(
      (item) => item.dish.dish_name === dish.dish_name
    );

    if (existingDish) {
      // Dish already exists, update the count
      const updatedDishes = orderedDishes.map((item) =>
        item.dish.dish_name === dish.dish_name ? { dish, count } : item
      );
      setOrderedDishes(updatedDishes);
    } else {
      // Dish doesn't exist, add a new entry
      setOrderedDishes((prevDishes) => [...prevDishes, { dish, count }]);
    }
  };

  const uniqueSectionNames = [
    ...new Set(restaurant.menu_sections.map((item) => item.section_name)),
  ];
  const total = orderedDishes.reduce(
    (accumulator, item) => accumulator + item.dish.dish_price * item.count,
    0
  );

  // const handleSelectRatingChange = async (event) => {
  //   setSelectRating(event.target.value);
  //   console.log(event.target.value);
  //   console.log(restaurant._id);
  //   await fetch("https://femez.onrender.com/API/restaurant/addUpdateRates", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${localStorage.getItem("token")}`,
  //     },
  //     body: JSON.stringify({
  //       restaurantId: restaurant._id,
  //       rating: event.target.value,
  //     }),
  //   });
  // };

  return (
    <div className="MyRestaurant-container">
      <div className="cover">
        <img src={`https://femez.onrender.com/${restaurant.cover}`} />
        <AddToFavorite
          restaurant_id={restaurant._id}
          setIsClicked={setIsClicked}
          isClicked={isClicked}
        />
        {/* // ! change the logo here if there is logo put it else display none */}
        {/* <img src={addLogo} className="restaurant-logo"></img> */}
      </div>

      <ScrollToTopButton />
      <div className="restaurant-details">
        <label className="restaurant-name">{restaurant.restaurant_name}</label>

        <label className="restaurant-category">
          {restaurant.restaurant_category}
        </label>
        <label className="restaurant-review">
          <span className="star-icon">
            <FaStar />
          </span>
          :{restaurant.restaurant_review}
        </label>
      </div>
      {showLogIn && (
        <div className="login-container">
          <div className="login">
            <LogIn
              setShowLogIn={setShowLogIn}
              setShowConfirmationPayment={setShowConfirmationPayment}
            />
          </div>
        </div>
      )}

      <div className="menu-sections-container">
        <div className={`menu-sections ${isSticky ? "sticky" : ""}`}>
          <div
            className="scroll-button-left-container"
            onClick={handleScrollButtonClickLeft}
          >
            <FaAngleDoubleLeft className="scroll-button-left" />
            {/* <button className="scroll-button-left">&lt;</button> */}
          </div>
          <div className="menu-sections-list">
            {uniqueSectionNames.map((section, index) => (
              <div
                key={index}
                className="menu-section-item"
                onClick={() => scrollToSection(index)}
              >
                <div className="menu-section-content">{section}</div>
              </div>
            ))}
          </div>
          <div
            className="scroll-button-right-container"
            onClick={handleScrollButtonClickRight}
          >
            <FaAngleDoubleRight className="scroll-button-right" />
            {/* <button className="scroll-button-right">&gt;</button> */}
          </div>
        </div>
        <div className="menu-sections-content-basket">
          <div className="menu-sections-content">
            <div className="menu-sections-dishes">
              {uniqueSectionNames.map((section, index) => (
                <div
                  key={`section-${index}`}
                  className="menu-section-item"
                  ref={(ref) => (sectionRefs.current[index] = ref)}
                >
                  <div className="menu-section-content">
                    <div className="menu-section-name"> {section}</div>

                    {restaurant.menu_sections[index] &&
                    restaurant.menu_sections[index].dishes &&
                    restaurant.menu_sections[index].dishes.length > 0 ? (
                      <div className="dishes-list">
                        {restaurant.menu_sections[index].dishes.map(
                          (dish, dishIndex) => (
                            <div
                              key={`dish-${dishIndex}`}
                              className="dish-container"
                            >
                              <div className="dish-item">
                                <div className="dish-details">
                                  <div>
                                    <h3>{dish.dish_name}</h3>
                                    <p>{dish.dish_description}</p>
                                  </div>
                                  <h3>Price: {dish.dish_price} € </h3>
                                </div>
                                <div>
                                  {dish.dish_image && (
                                    <img
                                      src={`https://femez.onrender.com/${dish.dish_image}`}
                                    />
                                  )}
                                </div>
                              </div>
                              <ItemCounter
                                key={`item-counter-${dishIndex}`}
                                onAddToOrder={(count) =>
                                  handleAddToOrder(
                                    restaurant.menu_sections[index].dishes[
                                      dishIndex
                                    ],
                                    count
                                  )
                                }
                              />
                            </div>
                          )
                        )}
                      </div>
                    ) : (
                      <p>No dishes available in this section yet</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="basket">
            <div className="order-summary-title">Order summary</div>
            <div>
              {orderedDishes.length === 0 ? (
                <div className="order-summary-item">
                  No items in the order yet
                </div>
              ) : (
                orderedDishes.map((item, i) => (
                  <div
                    key={`order-summary-item-${i}`}
                    className="order-summary-item"
                  >
                    <p>
                      {item.dish.dish_name} (×{item.count})
                    </p>
                    <p>Price: {item.dish.dish_price * item.count} €</p>
                  </div>
                ))
              )}
            </div>
            {orderedDishes.length !== 0 && (
              <div className="total-price">
                <div>Total</div> <div>{total} €</div>
              </div>
            )}
            <div className="order-button-container">
              <button
                className="order-button"
                onClick={() => {
                  if (orderedDishes.length > 0) {
                    if (localStorage.getItem("token")) {
                      setShowConfirmationPayment(true);
                      setErrorOrder(false);
                    } else {
                      sessionStorage.setItem("order", true);
                      setShowLogIn(true);
                    }
                  } else {
                    setErrorOrder(true);
                  }
                }}
              >
                Order
              </button>
              {errorOrder && orderedDishes.length === 0 && (
                <div style={{ color: "red" }}>
                  You dont have any items in your order yet
                </div>
              )}
            </div>
          </div>
          {showConfirmationPayment && orderedDishes.length !== 0 && (
            <div className="confirmation-payment-main-container">
              <div className="confirmation-payment-container">
                <div className="confirmation-payment">
                  <div className="total-price">
                    Total price of your order:
                    <div className="total">{total} € </div>
                  </div>
                  <div className="payment-method-selection">
                    <h3>Select Payment Method</h3>
                    <div className="payment-method-options">
                      <label>
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="creditCard"
                          checked={selectedMethod === "creditCard"}
                          onChange={() =>
                            handlePaymentMethodSelect("creditCard")
                          }
                        />
                        Credit Card
                      </label>
                    </div>

                    <div className="payment-method-options">
                      <label>
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="cash"
                          checked={selectedMethod === "cash"}
                          onChange={() => handlePaymentMethodSelect("cash")}
                        />
                        Cash
                      </label>
                    </div>
                    {errorSelectedMethod && (
                      <div className="error-message">
                        Please select a payment method
                      </div>
                    )}
                  </div>
                  <div className="form-actions">
                    <button onClick={handleConfirmOrder}>
                      Confirm And Order
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setShowConfirmationPayment(false);
                        setErrorSelectedMethod(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showTimeEstimation && (
            <div className="confirmation-payment-main-container">
              <div className="confirmation-payment-container">
                <div className="confirmation-payment">
                  <div className="message-and-Estimat-time">
                    <p className="thank-you-message">
                      <div className="celebration-message">
                        {" "}
                        Thank you for placing your order!{" "}
                        <img src={Celebration} className="celebration-icon" />
                      </div>
                    </p>
                    Your delicious food will be on its way. Estimated delivery
                    time is{" "}
                    <div className="Estimat-time">
                      {estimatedTime} - {estimatedTime + 20}{" "}
                    </div>{" "}
                    minutes.
                  </div>

                  <CountdownCircleTimer
                    isPlaying
                    duration={(estimatedTime + 20) * 60}
                    colors={"#edc669"}
                  >
                    {({ remainingTime }) => {
                      const minutes = Math.floor(remainingTime / 60);
                      const seconds = remainingTime % 60;
                      return (
                        <div style={{ textAlign: "center" }}>
                          {minutes}:{seconds < 10 ? `0${seconds}` : seconds}{" "}
                          <div>Minutes</div>
                        </div>
                      );
                    }}
                  </CountdownCircleTimer>
                  <RateRestaurant restaurantId={restaurant._id} />
                  <div className="buttons-container">
                    <button
                      onClick={() => {
                        navigate(`/`);
                      }}
                      className="main-page-button"
                    >
                      Return to Main Page
                    </button>
                    <button
                      onClick={() => {
                        setShowTimeEstimation(false);
                      }}
                      className="close-button"
                    >
                      Stay on this restaurant page
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default RestaurantView;
